export type OnboardingSummary = {
    status: 'IN_PROGRESS' | 'COMPLETED';
    completed_steps: number;
    total_steps: number;
    completion_percentage: number;
};

export function formatOnboardingListLabel(summary: OnboardingSummary | null | undefined): string {
    if (!summary) {
        return '-';
    }
    const icon = summary.status === 'COMPLETED' ? '🟢' : '🟡';
    const label = summary.status === 'COMPLETED' ? 'Completed' : 'In Progress';
    return `${icon} ${label} (${summary.completed_steps}/${summary.total_steps})`;
}
